import { FREE } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { highestProductLevelFromProductInventorySelector } from '../selectors/ProductInventorySelectors';
import { useGlobalLoading } from './loadingHooks';
export const useAddOnsPage = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isAppReady = useGlobalLoading();
  const isFreePortal = useAppSelector(state => {
    if (!isAppReady) return false;
    return highestProductLevelFromProductInventorySelector(state) === FREE;
  });
  const showAddonsPage = isAppReady && isAppAuth && !isFreePortal;
  return {
    showAddonsPage
  };
};